import { DOMAIN_PATTERNS } from '../regex/constants';

/**
 * DNS domain label: letters, digits, and hyphens; starts and ends with a letter or digit.
 * Labels are at most 63 characters.
 */
export const RFC1035_LABEL_REGEX =
  /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/;

/**
 * Domain with two or more dot-separated labels (e.g. example.com or 9foo.net).
 * Use validateDomainRfc1035 for the 255-character total length limit.
 */
const RFC1035_DOMAIN_REGEX =
  /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;

const RFC1035_MAX_DOMAIN_LENGTH = 255;

export const validateDomainRfc1035 = (domain: string): boolean => {
  const trimmed = domain.trim();
  if (!trimmed || trimmed.length > RFC1035_MAX_DOMAIN_LENGTH) {
    return false;
  }
  if (trimmed.endsWith('.')) {
    return false;
  }
  return RFC1035_DOMAIN_REGEX.test(trimmed);
};

export const validateDomain = (domain: string) => {
  const regex = DOMAIN_PATTERNS.DOMAIN;
  return regex.test(domain);
};

export const validateDomainPath = (url: string) => {
  const regex = DOMAIN_PATTERNS.DOMAIN_PATH;
  return regex.test(url);
};
